export default __webpack_public_path__ + "static/media/fr.c0c5d8fb.svg";